module.exports = __webpack_public_path__ + "logo-weebox-minified.png?8b98905ceb07fc85441129d340b41323";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-weebox-minified.png
// module id = 525
// module chunks = 0